import { useEffect, useRef, useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Badge, Typography, makeStyles, Button, Chip } from "@material-ui/core"
import { ExpandMore, LocationOn } from "@material-ui/icons"
import _ from 'lodash'
import { getDistrictName } from "../../../utilities/common"
import OrderInfo from "../SelectableOrderInfo"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme)=> ({
    badgeGroupRoot: {
        '& > *': {
          marginLeft: theme.spacing(1),
        },
    },
    badgeWithoutContent: {
        top: 'unset',
        right: 'unset'
    },
    badgeWithoutContentExpress: {
        top: 'unset',
        right: 'unset',
        backgroundColor: 'green'
    }
}))

function AccountList(props){
    const classes = useStyles()
    const {t} = useTranslation('common')

    const [expand, setExpand] =  useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const layersGeojson = useRef([]);

    const clearLayers = () => {
        if(layersGeojson?.current?.length > 0) {
            layersGeojson.current.forEach((item) => {
                item.layer.remove(item.geoJson[0]);
            })
        }
        layersGeojson.current = [];
    }
    const addLayers = (layers) => {
        layersGeojson.current.push(...layers);
    }

    useEffect(() => {
        if(props.checkedOrders) {
            if(props.checkedOrders.length > 0) {
                setIsChecked(true);
            } else {
                setIsChecked(false);
            }
        } else {
            setIsChecked(false);
        }
    }, [props.checkedOrders])

    return (
        <div style={{height: '95%', overflowY: 'scroll', overflowX: 'hidden'}}>
            {_.map(props.data, (staffs, key) =>{
                return (
                    <Accordion key={`account-list-${props.id}-${key}`} style={{width: '100%'}} onChange={_handleExpandAccordion}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <LocationOn />{
                            window.localStorage.getItem('districts')&&
                            <Typography style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
                                {getDistrictName(key)}
                            </Typography>
                        }
                            <div className={classes.badgeGroupRoot}>
                                {   
                                    getDistrictDriverOrderCount(staffs) !== 0 &&
                                    <Chip 
                                        label={getDistrictDriverOrderCount(staffs)}
                                        size='small'
                                        style={{ backgroundColor: 'red', color: "white" }}
                                    />
                                }
                                {   
                                    getDistrictDriverOrderCountExpress(staffs) !== 0 &&
                                    <Chip 
                                        label={getDistrictDriverOrderCountExpress(staffs)}
                                        size='small'
                                        style={{ backgroundColor: 'green', color: "white" }}
                                    />
                                }
                            </div>
                        </AccordionSummary>
                        <AccordionDetails style={{flexDirection: 'column'}}>
                        {staffs.map((account, index) => (
                            <div key={`staff-list-${index}`} style={{display: 'flex'}}>
                                {
                                    props.usageFor === 'local_delivery'
                                    &&
                                    <Button 
                                        color='primary' 
                                        disabled={!isChecked}
                                        onClick={() => props.handleDriverTransfer(account.id)}
                                    >
                                        {t('assign')}
                                    </Button>
                                }
                                <OrderInfo
                                    transferType={props.transferType}
                                    routeInfo={props.routeInfo}
                                    reset={props.reset}
                                    weightFilterTotal={props.weightFilterTotal}
                                    handleAccountListDropOff={props.handleAccountListDropOff}
                                    handleServicePointViewOpen={props.handleServicePointViewOpen}
                                    servicePointViewOpen={props.servicePointViewOpen}
                                    loading={props.sectionLoading}
                                    staffOrders={props.orderList[account.id]}
                                    filter={_.find(props.filter, {'driverId': account.id})}
                                    showPhoneNumber={props.showPhoneNumber}
                                    areaExpanded={expand}
                                    data={account}
                                    key={`order-info-${account.id}`}
                                    index={index}
                                    clearLayers={clearLayers}
                                    addLayers={addLayers}
                                />
                            </div>
                            
                        ))}
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </div>
    )

    function _handleExpandAccordion(event, expanded){
        setExpand(expanded)
    }

    function getDistrictDriverOrderCount(drivers){
        let totalOrderCount = _.reduce(drivers, (sum, driver)=> {
            if(!_.has(driver, 'order_count')){
                return sum
            }
            return driver.order_count + sum
        }, 0)
        let totalRoutePlannedCount = _.reduce(drivers, (sum, driver)=> {
            if(!_.has(driver, 'route_planned_count')){
                return sum
            }
            return driver.route_planned_count + sum
        }, 0)

        if (totalOrderCount === 0) return 0
        if (totalOrderCount > 0 && totalRoutePlannedCount === 0) return totalOrderCount
        if (totalOrderCount > 0 && totalRoutePlannedCount > 0) return `${totalRoutePlannedCount}/${totalOrderCount}`
    }


    function getDistrictDriverOrderCountExpress(drivers){
        let totalOrderCountExpress = _.reduce(drivers, (sum, driver)=> {
            if(!_.has(driver, 'express_count')){
                return sum
            }
            if(driver.express_count) {
                return driver.express_count + sum
            } else {
                return sum
            }
        }, 0)
        return totalOrderCountExpress;
    }
}

AccountList.defaultProps = {
    id: 0,
    data: {},
    orderList: {},
    showPhoneNumber: false,
    sectionLoading: false
}

export default AccountList